import React from 'react';
import './List.css';

function ListHeader({children, gridTemplateColumns = '1fr', size = 'big', className = ''}) {
  return (
    <div className={`listContainerHeader ${size} ${className}`} style={{gridTemplateColumns: `${gridTemplateColumns}`}}>
      {children}
    </div>
  );
}

export default ListHeader